/* eslint-disable no-nested-ternary */

export const validatePassword = (input, clickedSecondInput) => {
  const value = typeof input === 'string' ? input : '';
  const isLengthValid = value.length >= 8 && value.length <= 20;
  const hasUpperCase = value.split('').some(char => char >= 'A' && char <= 'Z');
  const hasLowerCase = value.split('').some(char => char >= 'a' && char <= 'z');
  const hasNumber = value.split('').some(char => char >= '0' && char <= '9');
  const specialChars = '@:._';
  const hasSpecialChar = value.split('').some(char => specialChars.includes(char));
  const noWhiteSpace = !value.includes(' ') && !value.includes('\t') && !value.includes('\n') && !value.includes('\r');

  const lengthStatus = isLengthValid
    ? 'check'
    : clickedSecondInput === true && !isLengthValid
    ? 'error'
    : 'disabled';
    
  const upperCaseStatus = hasUpperCase
    ? 'check'
    : clickedSecondInput === true && !hasUpperCase
    ? 'error'
    : 'disabled';
    
  const lowerCaseStatus = hasLowerCase
    ? 'check'
    : clickedSecondInput === true && !hasLowerCase
    ? 'error'
    : 'disabled';
    
  const specialCharStatus = hasSpecialChar
    ? 'check'
    : clickedSecondInput === true && !hasSpecialChar
    ? 'error'
    : 'disabled';
    
  const whiteSpaceStatus = noWhiteSpace
    ? 'check'
    : clickedSecondInput === true && !noWhiteSpace
    ? 'error'
    : 'disabled';

  const numberStatus = hasNumber
    ? 'check'
    : clickedSecondInput === true && !hasNumber
    ? 'error'
    : 'disabled';

  const totalValid =
    isLengthValid && hasUpperCase && hasLowerCase && hasSpecialChar && noWhiteSpace && hasNumber;
    
  return {
    lengthStatus,
    upperCaseStatus,
    lowerCaseStatus,
    specialCharStatus,
    whiteSpaceStatus,
    numberStatus,
    totalValid,
  };
};